﻿import $ from "jquery";

/* Enables "Campaign" features.
----------------------------------------------------------*/
export default function (urls, logCall) {
	for (var key in urls) {
		if (urls.hasOwnProperty(key)) {
			var mode = getMode(key);
			var urlValue = urls[key];

			if (mode && urlValue)
				enableCampaignLinks(mode, urlValue, logCall);
		}
	}
}

/* Get "Campaign" mode.
----------------------------------------------------------*/
function getMode(key) {

	switch (key) {
		case "legacyOfficeUrl":
			return "buy-office";

		case "legacyWindowsUrl":
			return "buy-windows";

		case "legacyServerUrl":
			return "buy-server";

		case "legacyCloudUrl":
			return "buy-cloud";

		case "buyNowUrl":
			return "buy-button";

		case "tryNowUrl":
			return "try-button";
	}

	return null;
};

/* Initialize "Campaign" features.
----------------------------------------------------------*/
function enableCampaignLinks(mode, url, logCall) {
	var buttonSelector = ".ccs-" + mode;

	var linkSelector = buttonSelector + " a, a" + buttonSelector;
	$(linkSelector)
		.each(function () {
			const a = $(this);
			if (a.attr("href") === "{Value}" || a.hasClass("ccs-update-href")) {
				a.attr("href", url);
			}
		})
		.click(function () {
			const href = $(this).attr("href");
			const clientParams = {
				Action: mode === "try-button" ? "try-now" : "buy-now",
				ActionContext: href
			};

			ccs_cc_log.dispatchEvent(logCall, clientParams);
		});

	$(buttonSelector).show();
}
